const schemaReduced = {
  id: "",
  number: "",
  serial: ""
};

export default schemaReduced;
